import React, { useState, useEffect } from "react";
import {
    Button,
    TextField,
    Snackbar,
    IconButton,
    Alert,
    Avatar,
    FormControlLabel,
    Checkbox,
    Box,
    InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import logo from "../GlobalCompos/logo.png";

export default function Login() {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);

    const [open, setOpen] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [severity, setSeverity] = useState("warning");

    // Check for saved credentials on load
    useEffect(() => {
        const savedEmail = localStorage.getItem("savedEmail");
        const savedPassword = localStorage.getItem("savedPassword");
        
        let localAuthValue = localStorage.getItem("vdcLogin")
        if ((savedEmail && savedPassword) || localAuthValue) {
            // auto-login
            console.log('localAuthValue',localAuthValue)
            if (
                (savedEmail === "shivachilveri@gmail.com" &&
                    savedPassword === "Vrindavan108") ||
                (savedEmail === "admin" && savedPassword === "admin")
                ||
                localAuthValue
            ) {
                window.localStorage.setItem("vdcLogin", true);
                navigate("/add-properties");
            }
        }
    }, [navigate]);

    const authenticate = () => {
        if (!email || !password) {
            setErrorMsg("No blank values allowed!");
            setSeverity("warning");
            setOpen(true);
            return;
        }

        if (
            (email === "shivachilveri@gmail.com" &&
                password === "f9G#2kL8@qR1vX7m") ||
            (email === "admin" && password === "admin")
        ) {
            window.localStorage.setItem("vdcLogin", true);

            // Save credentials if Remember Me is checked
            if (rememberMe) {
                localStorage.setItem("savedEmail", email);
                localStorage.setItem("savedPassword", password);
            } else {
                localStorage.removeItem("savedEmail");
                localStorage.removeItem("savedPassword");
            }

            navigate("/add-properties");
        } else {
            setErrorMsg("Email or Password Incorrect!");
            setSeverity("error");
            setOpen(true);
        }
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") return;
        setOpen(false);
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background:
                    "linear-gradient(135deg, #e0f7fa, #80deea)", // simple background, replace with image if needed
                p: 2,
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    maxWidth: 450,
                    p: 4,
                    textAlign: "center",
                    borderRadius: 3,
                    bgcolor: "white",
                    boxShadow: 6,
                }}
            >
                <Avatar
                    src={logo}
                    alt="Logo"
                    sx={{ width: 100, height: 100, mx: "auto", mb: 2 }}
                    variant="square"
                />

                <h2>Skyline Properties</h2>
                <p>Login with the credentials provided in email</p>

                <TextField
                    label="Email"
                    variant="outlined"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                />

                <TextField
                    label="Password"
                    variant="outlined"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    fullWidth
                    sx={{ mb: 1 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                            color="primary"
                        />
                    }
                    label="Remember Me"
                    sx={{ mb: 2 }}
                    style={{ float: 'left' }}
                />

                <Button
                    variant="contained"
                    fullWidth
                    onClick={authenticate}
                    sx={{ backgroundColor: "#0288d1", ":hover": { backgroundColor: "#0277bd" } }}
                >
                    Login
                </Button>

                <Snackbar
                    open={open}
                    autoHideDuration={3000}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                    <Alert severity={severity} onClose={handleClose} variant="filled">
                        {errorMsg}
                    </Alert>
                </Snackbar>
            </Box>
        </Box>
    );
}
